import dayjs from "./dayjs";
import { formatRuntime } from "./formatRuntime";

// TODO - Currently Hacky Implementation, need to modify to strict typing and expected object
export function parseTicketMasterEvents(events: any) {
  const parsedEvents = events._embedded.events.map((event: any) => {
    const date = dayjs(event.dates.start.localDate).toDate();
    const day = date
      .toLocaleDateString("en-US", { weekday: "short" })
      .toUpperCase();
    const formattedDate = date.toLocaleDateString("en-US", {
      month: "numeric",
      day: "numeric",
    });
    const time = formatRuntime(event.dates.start.localTime);
    const location =
      event._embedded?.venues[0]?.city?.name +
        ", " +
        event._embedded?.venues[0]?.state?.name || "N/A";
    const venue = event._embedded?.venues[0]?.name || "N/A";
    const ticketLink = event.url || "N/A";

    return {
      date: formattedDate,
      day,
      time,
      location,
      venue,
      ticketLink,
    };
  });

  const uniqueEvents = Array.from(
    new Set(parsedEvents.map((event: any) => event.date))
  ).map((date) => parsedEvents.find((event: any) => event.date === date));

  const sortedEvents = uniqueEvents.sort(
    (a, b) => dayjs(a.date).unix() - dayjs(b.date).unix()
  );

  return sortedEvents;
}
